import {Component, inject, input, ChangeDetectionStrategy} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {ReCaptchaV3Service} from 'ngx-captcha';

@Component({
    selector: 'app-captcha',
    templateUrl: './captcha.component.html',
    styleUrl: './captcha.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CaptchaComponent {
  captchaFieldName = input.required<string>();
  form = input.required<FormGroup>();

  private reCaptchaV3Service = inject(ReCaptchaV3Service);

  execute(): void {
    this.reCaptchaV3Service.execute('6LeMhXsaAAAAAJGLeSpf_zsNhZkZm8edYQwKXIwK', 'homepage', (token) => {
      console.log('This is your token: ', token);
      this.form().get(this.captchaFieldName())?.setValue(token);
    }, {
      useGlobalDomain: false // optional
    });
  }
}
